import { EasyBrief } from './components/EasyBrief';
import { TipsAndGuides } from './components/TipsAndGuides';

export const HowToSectionV3: React.FC = () => {
	return (
		<>
			<EasyBrief />
			<TipsAndGuides />
		</>
	);
};
